module.exports = __webpack_public_path__ + "mo/img/ico-26ver-benfit02.a9743d8e.png";